import qs from 'qs'

export const queryTicketPage = () => {
  const query = qs.stringify(
    {
      populate: {
        ...queryFragmentSingleTypeDefault,
        images: true,
        sections: {
          populate: {
            items: true
          }
        }
      }
    },
    {
      encodeValuesOnly: true
    }
  )

  return `ticket-page?${query}`
}
